import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../assets/logo.png";

const FooterSection = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollClick = (e, target) => {
    e.preventDefault();

    // If not on home page, navigate to home first
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.querySelector(target);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <footer className="footer-main pb-1">
      <Container>
        <Row className="d-flex justify-content-evenly">
          {/* Company Info */}
          <Col md={4} sm={12}>
            <div className="d-flex align-items-center justify-center mb-0">
              <img
                src={Logo}
                alt="WriteOffGenie Logo"
                style={{ width: "50px", height: "50px", marginRight: "10px" }}
              />
              <p className="text-light pt-2 mb-2 fs-6">
                <h4 className="m-0 fw-bold">WriteOffGenie</h4>
                Never miss a potential write-off.<br />
              </p>
            </div>


          </Col>

          {/* Product */}
          <Col md={2} sm={6}>
            <h5 className="fw-bold mb-3 mt-4 text-uppercase">Product</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="#features"
                  className="text-light text-decoration-none"
                  onClick={(e) => handleScrollClick(e, "#features")}
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#reviews"
                  className="text-light text-decoration-none"
                  onClick={(e) => handleScrollClick(e, "#reviews")}
                >
                  Reviews
                </a>
              </li>
            </ul>
          </Col>

          {/* Company */}
          <Col md={2} sm={6}>
            <h5 className="fw-bold mb-3 mt-4 text-uppercase">Company</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="#about"
                  className="text-light text-decoration-none"
                  onClick={(e) => handleScrollClick(e, "#about")}
                >
                  About
                </a>
              </li>
              <li>
                <Link
                  to="/support"
                  className="text-light text-decoration-none"
                >
                  Support
                </Link>
              </li>
            </ul>
          </Col>

          {/* Legal */}
          <Col md={3} sm={6}>
            <h5 className="fw-bold mb-3 mt-4 text-uppercase">Legal</h5>
            <ul className="list-unstyled">
              <li>
                <Link
                  to="/privacy"
                  className="text-light text-decoration-none"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-light text-decoration-none"
                >
                  Terms & Conditions
                </Link>
              </li>

            </ul>
          </Col>
        </Row>

        {/* Footer Bottom */}
        <Row className="mt-5 mb--2">
          <Col className="text-center text-secondary fs-6">
            © {new Date().getFullYear()} WriteOffGenie. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default FooterSection;
